<div>
    <aeg-test-payment-data/>

    <div class="aeg-flex-col-g4">

        <!-- Online betaling -->
        <label
            for="payment-method-card"
            :class="[
                'flex cursor-pointer items-start gap-3 rounded-2xl border p-4 transition-colors hover:bg-surface-100',
                inputValue === 'card'
                  ? 'border-primary-500'
                  : 'border-surface-300'
              ]"
        >
            <RadioButton
                v-model="inputValue"
                inputId="payment-method-card"
                name="payment-method"
                value="card"
                class="shrink-0"
            />

            <div class="flex-1 aeg-flex-col-g4">
                <span class="font-medium leading-none">
                  Online betaling
                </span>

                <div class="card-logos flex items-center gap-2">
                    <img :src="mastercard" alt="Mastercard"/>
                    <img :src="visa" alt="Visa"/>
                    <img :src="bancontact" alt="Bancontact"/>
                </div>
            </div>
        </label>

        <!-- Prepaid -->
        <div
            v-if="allowPrepaid"
            :class="[
                'overflow-hidden rounded-2xl border transition-colors',
                prepaidDisabled
                  ? 'border-surface-200 bg-surface-100'
                  : inputValue === 'prepaid'
                    ? 'border-primary-500'
                    : 'border-surface-300'
              ]"
        >
            <!-- Selecteerbaar gedeelte -->
            <label
                for="payment-method-prepaid"
                :class="[
                  'flex items-start gap-4 p-4',
                  prepaidDisabled
                    ? 'cursor-not-allowed'
                    : 'cursor-pointer hover:bg-surface-100'
                ]"
            >
                <RadioButton
                    v-model="inputValue"
                    inputId="payment-method-prepaid"
                    name="payment-method"
                    value="prepaid"
                    :disabled="prepaidDisabled"
                    :class="['shrink-0', { 'opacity-50': prepaidDisabled }]"
                />

                <div class="flex-1 flex flex-col gap-3">
                    <span :class="['font-medium leading-none', { 'opacity-50': prepaidDisabled }]">
                        {{ prepaidTitle }}
                    </span>

                    <template v-if="userHadPrepaidBefore">
                        <div class="prepaid-saldo">
                            Huidig saldo:

                            <span
                                :class="{
                                  'prepaid-saldo__value': true,
                                  'prepaid-saldo__value--sufficient': hasSufficientPrepaidBalance
                                }"
                            >
                            {{ formatCurrency(prepaidBalance) }}
                            </span>

                            <span
                                v-if="!hasSufficientPrepaidBalance"
                                class="prepaid-saldo__deficiency"
                            >
                                {{ formatCurrency(prepaidBalanceDeficiency) }} te weinig
                            </span>

                            <!-- Aanvullink -->
                            <a
                                href="#"
                                class="prepaid-saldo__link"
                                @click.prevent.stop="addPrepaid"
                            >
                                Aanvullen
                            </a>
                        </div>
                    </template>

                    <a
                        v-else
                        href="#"
                        class="prepaid-saldo__link"
                        @click.prevent.stop="addPrepaid"
                    >
                        Laad prepaid saldo op
                    </a>
                </div>

            </label>
        </div>

    </div>
</div>
